import { useMemo } from 'react';
import hash from 'object-hash';

import getCityParameters from '@/features/dealers/helpers/getCityParameters';
import { useAppSelector } from '@/features/hooks';
import { rootQueriesApi, rootSelectors } from '@/features/store';
import useAppFetch from '@/hooks/useAppFetch';

type Props = {
  collectionId?: string;
  itemId?: string;
};

const useCityData = ({ collectionId, itemId }: Props) => {
  const config = useAppSelector(rootSelectors.config.configSelector);

  const parameters = useMemo(() => {
    return getCityParameters(config, collectionId!, itemId);
  }, [config, collectionId, itemId]);

  const isSkip = !collectionId;

  const [fetchCities, queryResult] = rootQueriesApi.dealers.useLazyGetCityQuery();

  useAppFetch(
    async () => {
      await fetchCities(parameters, true).unwrap();
    },
    [parameters],
    { ssr: hash(parameters), skip: isSkip },
  );

  return queryResult;
};

export default useCityData;
